module.exports = __webpack_public_path__ + "img/scene-remoteops.3f12e6ed.jpg";